import styled from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'

const AlertOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  margin-top: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: ${(props) => (props.activeOverlay ? '#141A2180' : 'transparent')};
  z-index: 9999;
`

const AlertBase = styled.div`
  position: fixed;
  width: calc(100% - 2rem);
  max-width: ${({ width }) => width ?? '400px'};
  height: ${({ height }) => height ?? 'fit-content'};
  background-color: ${colorsOptions.greys['grey-10']};
  border-radius: 16px;
  box-shadow: -4px 8px 24px 0px rgba(20, 26, 33, 0.16);
  z-index: 99999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const AlertContentContainer = styled.div`
  padding: 1.5rem;
  gap: 1rem;
`

const ContentHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: 32px;
  padding-bottom: 1rem;
`

const HeaderContainerTitle = styled.span`
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]}
`

const ContentDescriptionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const DescriptionContainerText = styled.p`
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  letter-spacing: 0.2px;
`

const AlertActionsButtonsContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction};
  align-items: ${(props) =>
    props.direction === 'row' ? 'center' : props.align};
  justify-content: ${(props) =>
    props.direction === 'row' ? props.align : 'center'};
  padding: 24px 16px;
  gap: 0.5rem;
`

const AlertLoaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background: rgba(20, 26, 33, 0.25);
  border-radius: 16px;
`

const AlertWrapperStoryBook = styled.div`
  position: relative;
  width: 50vw;
  height: 50vh;
  overflow: hidden;
`

const ChildrenContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0 24px;
`

export {
  AlertOverlay,
  AlertBase,
  AlertContentContainer,
  ContentHeaderContainer,
  HeaderContainerTitle,
  ContentDescriptionContainer,
  DescriptionContainerText,
  AlertActionsButtonsContainer,
  AlertLoaderContainer,
  AlertWrapperStoryBook,
  ChildrenContainer
}
